var render = function render() {
    var _vm = this, _c = _vm._self._c;
    return _c('div', {
        class: _vm.$style.container
    }, [
        _c('h1', [
            _vm._v("404")
        ]),
        _c('p', [
            _vm._v("Ha accedido a una página que no existe")
        ])
    ]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
